/**
 * @generated SignedSource<<ff8cbdd3194994cab5b66e6fcedf87a9>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type Note_panelist$data = {
  readonly id: string;
  readonly tenantNote: {
    readonly id: string;
    readonly modified: any;
    readonly modifiedBy: {
      readonly firstName: string;
    } | null;
    readonly text: string | null;
  } | null;
  readonly " $fragmentType": "Note_panelist";
};
export type Note_panelist$key = {
  readonly " $data"?: Note_panelist$data;
  readonly " $fragmentSpreads": FragmentRefs<"Note_panelist">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "Note_panelist",
  "selections": [
    (v0/*: any*/),
    {
      "alias": null,
      "args": null,
      "concreteType": "NoteNode",
      "kind": "LinkedField",
      "name": "tenantNote",
      "plural": false,
      "selections": [
        (v0/*: any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "modified",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "UserNode",
          "kind": "LinkedField",
          "name": "modifiedBy",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "firstName",
              "storageKey": null
            }
          ],
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "text",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "PanelistNode",
  "abstractKey": null
};
})();

(node as any).hash = "ead7d79f2fc1f8d4198bed24198d553a";

export default node;
